<template>
  <div class="relative h-[281.25px] flex flex-col rounded-md bg-white min-w-[300px] w-[314] sm:min-w-[275px] sm:w-[275px] mr-4">
    <OLink pure :href="item.link" target="_blank" rel="nofollow noopener">
      <OImage
        :src="item.brand.logo"
        class="absolute top-[100px] right-4 w-13 h-13 bg-white border border-[#E2E5ED] rounded-full object-contain"
        alt="görsel"
        loading="lazy"
        draggable="false"
      ></OImage>
      <OImage class="object-cover h-[135px] w-full rounded-t-md" :src="imageUrl" alt="görsel" loading="lazy" draggable="false" />
    </OLink>
    <div class="flex flex-col justify-between h-full px-4 pt-5 pb-4">
      <h6 class="text-primary-100 text-base leading-24 tracking-tight font-semibold line-clamp-2">{{ item.title }}</h6>
      <div class="flex flex-start">
        <button class="u-center flex-nowrap border border-[#E2E5ED] rounded mr-2 py-1 px-4" @click="showVitrinModal">
          <p class="text-primary-300 text-13 leading-24 font-medium whitespace-nowrap">Detaylar</p>
          <img style="width: 18px; height: 18px" src="~/static/svg/right.svg" alt="" />
        </button>
        <OLink
          v-for="category in item.categories"
          :key="category._id"
          pure
          class="u-center flex-nowrap border border-[#E2E5ED] rounded mr-2 py-1 px-4"
          :href="getCategoryPath"
        >
          <p class="text-primary-300 text-13 leading-24 font-medium whitespace-nowrap mr-2">{{ category.name }}</p>
          <OIcon :icon="getIconPath(category.name)" svg-class="w-[18px] h-[18px] text-[#9B9B9B]" />
        </OLink>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { useModal } from '~/composables/useModal';
import { normalizeText } from '~/modules/common/utils/stringUtils';
import { OLink, OImage, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink, OImage, OIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const imageUrl = props.item?.coverPhoto;
    const { isMobile } = useDevice();
    const { openModal } = useModal();
    const getCategoryPath = computed(() => `/vitrin/${normalizeText(props.item.categories[0].name)}`);
    const getIconPath = (name) => `vitrin/icons/${normalizeText(name)}`;

    const showVitrinModal = () => {
      openModal(import('~/modules/vitrin/components/ModalVitrin' /* webpackChunkName: "ModalVitrin" */), (props = { item: props.item }));
    };

    return { imageUrl, isMobile, showVitrinModal, getCategoryPath, getIconPath };
  },
});
</script>
